export default __webpack_public_path__ + "f7ea991debb5aa3c05254cb08773b0e4.png";